import { Group, Stack, useMantineTheme } from '@mantine/core';
import { Icon, IconButton, Text } from '@repo/foundations';
import { memo } from 'react';
import type { IAiChat } from '../../../api/hooks/aiChats';

interface AiChatDrawer403Props {
	selectedChat: IAiChat | null;
	onClose: () => void;
}

export const AiChatDrawer403 = memo(
	({ selectedChat, onClose }: AiChatDrawer403Props) => {
		const theme = useMantineTheme();

		return (
			<Stack w="100%" h="100%" px="xl" py="sm">
				<Stack h="100%" spacing="xs">
					<Group position="apart" mb="md">
						<Group spacing="sm">
							{selectedChat && (
								<Text
									truncate
									maw={theme.other.space[90]}
									size="sm"
									weight="bold"
								>
									{selectedChat.title || selectedChat.prompt?.[0] || ''}
								</Text>
							)}
						</Group>
						<Group align="center" spacing="xs">
							<IconButton
								variant="tertiary"
								iconName="x"
								onClick={onClose}
								size="sm"
							/>
						</Group>
					</Group>
					<Stack h="100%" align="center" justify="center" spacing="sm">
						<Icon name="lock" size="lg" color="icon/primary/default" />
						<Text color="text/primary/default" fw="semibold">
							No access to this resource
						</Text>
						<Text size="sm" color="text/secondary/default">
							You do not have permissions to access this resource
						</Text>
					</Stack>
				</Stack>
			</Stack>
		);
	}
);
